export default "__VITE_ASSET__BE1hqIPl__"